import React from "react";
import { connect } from "react-redux"
import styles from "./FlashMessage.scss";

const FlashMessage = (props) => {
  const { isSuccess, isOpen, successMessage = '', failedMessage = '' } = props;

  const closeMessage = () => {
    props.setClose();
  }

  const flashClass = `${styles.flashMessage} ${
    isSuccess ? styles.success : styles.danger
  }`;
  
  const message = isSuccess ? (
    <p>{successMessage}</p>
  ) : (
    <p>{failedMessage}</p>
  );

  return (
    <div>
       {isOpen && (
        <div className='flashContainer'>
          <div className={flashClass}>
            {message}
            <button onClick={closeMessage}>×</button>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isSuccess: state.flashMessage.isSuccess,
    isOpen: state.flashMessage.isOpen
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setClose: () => dispatch({type: 'SET_CLOSE'}) 
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FlashMessage);
